import { defineMessages } from "react-intl";

export const orderProgressStepperMessages = defineMessages({
  submitted: {
    id: "HVzp7T",
    defaultMessage: "Submitted",
    description: "order progress step, order placed by customer",
  },
  payment: {
    id: "9EPgBG",
    defaultMessage: "Payment",
    description: "order progress step, payment received",
  },
  invoice: {
    id: "oG5tYB",
    defaultMessage: "Invoice",
    description: "order progress step, invoice generated",
  },
  preparation: {
    id: "2TeExf",
    defaultMessage: "Preparation",
    description: "order progress step, items being packed",
  },
  shipping: {
    id: "CH7ZMD",
    defaultMessage: "Shipping",
    description: "order progress step, parcel shipped",
  },
  received: {
    id: "eOoeBp",
    defaultMessage: "Received",
    description: "order progress step, order fulfilled",
  },
  collected: {
    id: "OYtcoo",
    defaultMessage: "Collected",
    description: "order progress step, in-store pickup order collected",
  },
  readyForPickup: {
    id: "4lYf1U",
    defaultMessage: "Ready for pickup",
    description: "order progress step, in-store pickup order prepared and customer told",
  },
  markPickupReadyAction: {
    id: "lezX80",
    defaultMessage: "Mark ready for pickup",
    description: "order progress, tell an in-store pickup customer the order is ready",
  },
  undoPickupReadyAction: {
    id: "KKpdKV",
    defaultMessage: "Undo",
    description: "order progress, revert the ready-for-pickup mark",
  },
  confirmOrderAction: {
    id: "GfDwgb",
    defaultMessage: "Confirm order",
    description: "order progress next action, confirm unconfirmed order",
  },
  markAsPaidAction: {
    id: "UQzans",
    defaultMessage: "Mark as paid",
    description: "order progress next action, settle payment",
  },
  generateInvoiceAction: {
    id: "i16v5T",
    defaultMessage: "Generate invoice",
    description: "order progress next action, create invoice",
  },
  sendPaymentReminderAction: {
    id: "sY5uql",
    defaultMessage: "Send payment reminder",
    description: "order progress, send an unpaid-order reminder email",
  },
  markInvoiceManuallyAction: {
    id: "mYnwBd",
    defaultMessage: "Mark as done manually",
    description: "order progress, fallback to mark invoice step complete without an invoicing app",
  },
  undoInvoiceAction: {
    id: "TZIjY2",
    defaultMessage: "Undo",
    description: "order progress, revert manual invoice-done mark",
  },
  markReceivedAction: {
    id: "sU+g3g",
    defaultMessage: "Mark as received",
    description: "order progress, manually complete the final received step",
  },
  undoReceivedAction: {
    id: "rfvRhX",
    defaultMessage: "Undo",
    description: "order progress, revert manual received mark",
  },
  resendSectionLabel: {
    id: "OOuuY9",
    defaultMessage: "Resend customer email",
    description: "order progress, label above the resend controls",
  },
  resendInvoiceAction: {
    id: "+KswEH",
    defaultMessage: "Resend invoice email",
    description: "order progress, resend the invoice notification",
  },
  resendShippingAction: {
    id: "5oEMm7",
    defaultMessage: "Resend shipping email",
    description: "order progress, resend the shipping/tracking notification",
  },
  resendConfirmationAction: {
    id: "vU2mOE",
    defaultMessage: "Resend confirmation email",
    description: "order progress, resend the order confirmation notification",
  },
  resendPaymentAction: {
    id: "7WHNZY",
    defaultMessage: "Resend payment email",
    description: "order progress, resend the payment confirmation notification",
  },
  fulfillAction: {
    id: "HCcf7F",
    defaultMessage: "Pack & ship",
    description: "order progress next action, pack items",
  },
  cannotFulfillUnpaid: {
    id: "1U4V5B",
    defaultMessage: "Cannot pack & ship an unpaid order",
    description: "order progress, fulfill disabled reason",
  },
  addTrackingAction: {
    id: "vESvI3",
    defaultMessage: "Add tracking number",
    description: "order progress next action, mark as shipped",
  },
  approveAction: {
    id: "lKN8qv",
    defaultMessage: "Approve fulfillment",
    description: "order progress next action, approve fulfillment",
  },
  nextStepLabel: {
    id: "wGxOWm",
    defaultMessage: "Next step",
    description: "order progress, label above the next action button",
  },
  cancelled: {
    id: "qxnUHf",
    defaultMessage: "This order was cancelled",
    description: "order progress, cancelled order",
  },
  expired: {
    id: "TEq2Av",
    defaultMessage: "This order has expired",
    description: "order progress, expired order",
  },
  trackingLabel: {
    id: "x4wcMO",
    defaultMessage: "Tracking: {trackingNumber}",
    description: "order progress, shipment tracking number or link",
  },
  pontoRecolhaMissing: {
    id: "9zJY+M",
    defaultMessage:
      "Shipped to a pickup point (Ponto de Recolha), but the pickup-point address is missing. The customer doesn't know where to collect the order yet.",
    description: "order progress, warning: parcel-shop order shipped without pickup-point address",
  },
  pontoRecolhaAddAction: {
    id: "5WuYUr",
    defaultMessage: "Add pickup-point address and email customer",
    description:
      "order progress, open dialog to enter the pickup-point address and resend shipping email",
  },
});
